export const pageTitle = (title) => {
  return ( document.title = title + " - Unleash New Dimensions");
}